import * as React from "react";
import { Box } from "@mui/material";

interface ChooseSizeSectionProps {
  show: boolean;
  currentSizeId?: number;
  otherSizes?: { id: number; product_id: number; name: string }[];
  onNavigateSize: (productId: number, sizeId: number) => void;
}

const ChooseSizeSection = ({
  show,
  currentSizeId,
  otherSizes = [],
  onNavigateSize,
}: ChooseSizeSectionProps) => {
  if (!show) return <div style={{ marginTop: 10 }}></div>;

  return (
    <div className="res-title choose-size ">
      <div className="res-title title-choose-size ">Choose size</div>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        {otherSizes?.length > 0 &&
          otherSizes.map((otherSize, index) => (
            <Box
              className="btn-size"
              key={index}
              sx={{ backgroundColor: "#f5f5f5 !important", mr: 0 }}>
              <button
                style={{
                  backgroundColor: currentSizeId !== otherSize.id ? "#fff" : "",
                }}
                onClick={() => onNavigateSize(otherSize.product_id, otherSize.id)}>
                {otherSize?.name}
              </button>
            </Box>
          ))}
      </Box>
    </div>
  );
};

export default ChooseSizeSection;
